export const USD_TO_GBP = 0.75;

export const USD_TO_EUR = 0.80;

export const USD_TO_JPY = 110;

export const USD_TO_INR = 80;

export const BLOG_LIST_MAX_BLOGS = 10;